import React from 'react';
import PropTypes from 'prop-types';
import { StyledPlayText } from './PlayText.styles';

export enum SIZE {
    MINI = 'MINI',
    SMALL = 'SMALL',
    DEFAULT = 'DEFAULT',
    LARGE = 'LARGE',
    XLARGE = 'XLARGE',
    XXLARGE = 'XXLARGE',
}

export type PlayTextProps = {
    fontColor?: string;
    size?: SIZE;
    weight?: string | number;
    underline?: boolean;
    children?: React.ReactChildren | React.ReactNode | string;
    className?: string;
    error?: boolean;
    dataRt?: string;
    as?: keyof JSX.IntrinsicElements;
};

const PlayText = ({
    fontColor,
    size,
    weight,
    underline,
    children,
    className,
    error,
    dataRt,
    as = 'p',
}: PlayTextProps): JSX.Element => (
    <StyledPlayText<typeof as>
        weight={weight}
        fontColor={fontColor}
        size={size}
        underline={underline}
        className={className}
        error={error}
        data-rt={dataRt}
        as={as}
    >
        {children}
    </StyledPlayText>
);
PlayText.propTypes = {
    size: PropTypes.oneOf(['MINI', 'SMALL', 'DEFAULT', 'LARGE', 'XLARGE']),
    underline: PropTypes.bool,
    children: PropTypes.node,
};
export default PlayText;
